var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCountIcon = function SvgCountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.643594 8.28868L14 0.57735L27.3564 8.28868V23.7113L14 31.4227L0.643594 23.7113V8.28868Z",
    stroke: "#3F7F7D"
  })));
};
export { SvgCountIcon as ReactComponent };
export default __webpack_public_path__ + "assets/bd07af1e.svg";